export class CrmDueEventView {
    id: number;
    dateDue: Date | null;
    title: string;
    memberId: number;
    memberFirstName: string;
    memberLastName: string;
    memberCompanyName: string;
    priorityId: number;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.dateDue = data?.dateDue ? new Date(data?.dateDue) : null;
        this.title = data?.title ?? "";
        this.memberId = data?.memberId ?? 0;
        this.memberFirstName = data?.memberFirstName ?? "";
        this.memberLastName = data?.memberLastName ?? "";
        this.memberCompanyName = data?.memberCompanyName ?? "";
        this.priorityId = data?.priorityId ?? 0;
    }
}